module.exports = __webpack_public_path__ + "files/85d8191f917e2826dcda30745767d08d.png";